import React from "react";

const AgendaListFilterPopup = () => {
  return <div>AgendaListFilterPopup</div>;
};

export default AgendaListFilterPopup;
